<template>
  <div>
    <div class="catalog__catalog-item-form">
      <input class="popap__content-general-input input-conditions" type="text" placeholder="Поиск"
             required="required" :value="search" @input="$emit('search', $event.target.value)">
      <reset-button @click="$emit('search', '')" class="catalog__input-btn-reset"/>
    </div>
    <div class="popap__content-wrapper">
      <div class="popap__content-not-found" v-if="!items.length">Ничего не найдено</div>
      <DynamicScroller
          :items="filteredItems"
          :min-item-size="33"
          class="popap__content-wrap"
      >
        <template v-slot="{ item, index, active }">
          <DynamicScrollerItem
              :item="item"
              :index="index"
              :active="active"
              :size-dependencies="[
              item.title,
            ]"
              class="popap__content-item"
          >
            <div class="filter-sort-container" v-if="isCategorized">
              <div class="filter-sort-letter-container">
                <span class="filter-sort-letter" v-show="hasLetter(index) && item.active">
                    {{ getFirstLetter(item.title) }}
                </span>
              </div>
              <div class="filter-sort-checkbox-container">
                <filter-checkbox
                    :disabled="!item.active"
                    :label="item.title"
                    :value="item.id"
                    :hint="item.description ? item.description : item.short_description"
                    :limit="limit"
                    :filter="filter"
                    @click.native.prevent="item.active ? $emit('filter', item.id) : null"/>
              </div>
            </div>
            <div v-else>
              <filter-checkbox
                  :disabled="!item.active"
                  :label="item.title"
                  :value="item.id"
                  :hint="item.description ? item.description : item.short_description"
                  :limit="limit"
                  :filter="filter"
                  @click.native.prevent="item.active ? $emit('filter', item.id) : null"/>
            </div>
          </DynamicScrollerItem>
        </template>
      </DynamicScroller>
    </div>
    <div v-if="getFoundCount !== null" class="popap__content-founded">
      Найдено {{ getFoundCount }}
    </div>
  </div>
</template>

<script>
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import FilterCheckbox from '@/components/FilterCheckbox'
import {DynamicScroller, DynamicScrollerItem} from 'vue-virtual-scroller'
import {mapGetters} from 'vuex'

let letterIndex = [];
export default {
  name: 'filer-block-popup-long',
  props: {
    search: {
      type: String,
      require: true
    },
    items: {
      type: Array,
      require: true
    },
    filter: {
      type: Array,
      require: true
    },
    limit: {
      type: [Array, Boolean],
      require: true
    },
    isCategorized: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FilterCheckbox,
    DynamicScroller,
    DynamicScrollerItem
  },
  computed: {
    filteredItems() {
      letterIndex = [];
      let items = this.items.reduce((allItems, [id, item]) => ([
        ...allItems,
        {
          id,
          ...item
        }
      ]), [])

      let letters = [];
      items.forEach(function (item, index) {
        let letter = item.title.substring(0, 1);
        if (!letters.includes(letter)) {
          letters.push(letter);
          letterIndex.push(index)
        }
      })
      return items;
    },
    ...mapGetters(['getFoundCount'])
  }, methods: {
    getFirstLetter(title) {
      return title.substring(0, 1)
    },
    hasLetter(index) {
      return letterIndex.includes(index)
    }
  }
}
</script>